const logContext = require("./logContext");

const PREFIX_KEYS = ["requestId", "visitId", "leadId", "op"];

function formatLogContext() {
  const context = logContext.get();

  if (!context) {
    return "";
  }

  const parts = [];

  PREFIX_KEYS.forEach(key => {
    if (context[key]) {
      parts.push(`${key}=${context[key]}`);
    }
  });

  if (parts.length === 0) {
    return "";
  }

  return `[${parts.join(" ")}]`;
}

module.exports = { formatLogContext };
